import { render, staticRenderFns } from "./invenPAndLStat.vue?vue&type=template&id=4334b421&scoped=true&"
import script from "./invenPAndLStat.vue?vue&type=script&lang=js&"
export * from "./invenPAndLStat.vue?vue&type=script&lang=js&"
import style0 from "./invenPAndLStat.vue?vue&type=style&index=0&id=4334b421&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4334b421",
  null
  
)

component.options.__file = "invenPAndLStat.vue"
export default component.exports